// frontend/src/DashboardAdmin.js
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';

// ✅ ADICIONAR A URL DA API
const API_URL = process.env.REACT_APP_API_URL || '';

function DashboardAdmin() {
  const [dados, setDados] = useState({
    totalEmpresas: 0,
    totalUsuarios: 0,
    totalReceitas: 0,
    totalDespesas: 0,
    saldo: 0,
    empresas: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isTablet = useMediaQuery({ maxWidth: 992 });
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchDados();
  }, []);

  const fetchDados = async () => {
    setLoading(true);
    setError('');
    try {
      // ✅ CORRIGIDO - Usando API_URL
      const responseEmpresas = await fetch(`${API_URL}/api/empresas`, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!responseEmpresas.ok) {
        const errorText = await responseEmpresas.text();
        console.error('Erro empresas:', errorText);
        throw new Error(`Erro ${responseEmpresas.status} ao buscar empresas`);
      }

      const empresas = await responseEmpresas.json();

      // ✅ CORRIGIDO - Buscar total de usuários
      const responseUsuarios = await fetch(`${API_URL}/api/usuarios?page=1&limit=1`, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      let totalUsuarios = 0;
      if (responseUsuarios.ok) {
        const usuariosData = await responseUsuarios.json();
        totalUsuarios = usuariosData.paginacao?.total || 0;
      }

      let totalReceitas = 0;
      let totalDespesas = 0;

      for (const empresa of empresas) {
        try {
          const response = await fetch(`${API_URL}/api/lancamentos/empresa/${empresa.id}`, {
            headers: { 
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (response.ok) {
            const lancamentos = await response.json();
            
            lancamentos.forEach(item => {
              const valor = Number(item.valor) || 0;
              if (item.tipo === 'RECEITA') {
                totalReceitas += valor;
              } else if (item.tipo === 'DESPESA') {
                totalDespesas += valor;
              }
            });
          }
        } catch (err) {
          console.error(`Erro ao buscar lançamentos da empresa ${empresa.id}:`, err);
        }
      }

      setDados({
        totalEmpresas: empresas.length || 0,
        totalUsuarios,
        totalReceitas,
        totalDespesas,
        saldo: totalReceitas - totalDespesas,
        empresas: empresas || []
      });
    } catch (err) {
      console.error('❌ Erro detalhado:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // ... O RESTO DO CÓDIGO PERMANECE IGUAL (formatCurrency, render, etc)
  // Mantenha todo o resto do componente igual

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '50px' }}>🔄 Carregando dados...</div>;
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <div style={{ fontSize: '48px', marginBottom: '10px' }}>❌</div>
        <p style={{ color: 'red', fontSize: isMobile ? '14px' : '16px' }}>Erro: {error}</p>
        <button 
          onClick={fetchDados}
          style={{ 
            marginTop: '10px', 
            padding: isMobile ? '8px 20px' : '10px 20px', 
            backgroundColor: '#007bff', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            fontSize: isMobile ? '13px' : '14px',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          Tentar Novamente
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: isMobile ? '10px' : '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Cabeçalho */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'flex-start' : 'center', 
        marginBottom: '20px',
        gap: '10px'
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: isMobile ? '20px' : '28px' }}>👑 Dashboard Administrativo</h2>
          <p style={{ color: '#6c757d', margin: '5px 0 0 0', fontSize: isMobile ? '13px' : '14px' }}>
            Visão geral de todas as empresas da plataforma
          </p>
        </div>
      </div>

      {/* Cards de Resumo */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: isMobile ? '1fr' : isTablet ? '1fr 1fr' : 'repeat(4, 1fr)', 
        gap: isMobile ? '10px' : '20px', 
        marginBottom: '30px' 
      }}>
        <div style={{ backgroundColor: '#cce5ff', padding: isMobile ? '15px' : '20px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
          <h3 style={{ margin: 0, color: '#004085', fontSize: isMobile ? '14px' : '18px' }}>🏢 Empresas</h3>
          <p style={{ fontSize: isMobile ? '22px' : '28px', fontWeight: 'bold', margin: '10px 0 0 0', color: '#004085' }}>
            {dados.totalEmpresas}
          </p>
        </div>
        <div style={{ backgroundColor: '#d4edda', padding: isMobile ? '15px' : '20px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
          <h3 style={{ margin: 0, color: '#155724', fontSize: isMobile ? '14px' : '18px' }}>👥 Usuários</h3>
          <p style={{ fontSize: isMobile ? '22px' : '28px', fontWeight: 'bold', margin: '10px 0 0 0', color: '#155724' }}>
            {dados.totalUsuarios}
          </p>
        </div>
        <div style={{ backgroundColor: '#d4edda', padding: isMobile ? '15px' : '20px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
          <h3 style={{ margin: 0, color: '#155724', fontSize: isMobile ? '14px' : '18px' }}>💰 Receitas</h3>
          <p style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: 'bold', margin: '10px 0 0 0', color: '#155724' }}>
            {formatCurrency(dados.totalReceitas)}
          </p>
        </div>
        <div style={{ backgroundColor: '#f8d7da', padding: isMobile ? '15px' : '20px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
          <h3 style={{ margin: 0, color: '#721c24', fontSize: isMobile ? '14px' : '18px' }}>💸 Despesas</h3>
          <p style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: 'bold', margin: '10px 0 0 0', color: '#721c24' }}>
            {formatCurrency(dados.totalDespesas)}
          </p>
        </div>
      </div>

      {/* DRE Consolidado */}
      <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '20px', borderRadius: '8px', marginBottom: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
        <h3 style={{ fontSize: isMobile ? '16px' : '18px' }}>📊 DRE Consolidado</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <td style={{ padding: isMobile ? '6px 8px' : '8px', borderBottom: '1px solid #dee2e6', fontSize: isMobile ? '13px' : '14px' }}>Receita Total</td>
                <td style={{ padding: isMobile ? '6px 8px' : '8px', borderBottom: '1px solid #dee2e6', textAlign: 'right', color: '#28a745', fontWeight: 'bold', fontSize: isMobile ? '13px' : '14px' }}>
                  {formatCurrency(dados.totalReceitas)}
                </td>
              </tr>
              <tr>
                <td style={{ padding: isMobile ? '6px 8px' : '8px', borderBottom: '1px solid #dee2e6', fontSize: isMobile ? '13px' : '14px' }}>(-) Despesas Totais</td>
                <td style={{ padding: isMobile ? '6px 8px' : '8px', borderBottom: '1px solid #dee2e6', textAlign: 'right', color: '#dc3545', fontWeight: 'bold', fontSize: isMobile ? '13px' : '14px' }}>
                  {formatCurrency(dados.totalDespesas)}
                </td>
              </tr>
              <tr>
                <td style={{ padding: isMobile ? '6px 8px' : '8px', fontWeight: 'bold', fontSize: isMobile ? '16px' : '18px', borderTop: '2px solid #dee2e6' }}>= Resultado Consolidado</td>
                <td style={{ padding: isMobile ? '6px 8px' : '8px', textAlign: 'right', fontWeight: 'bold', fontSize: isMobile ? '16px' : '18px', color: dados.saldo >= 0 ? '#28a745' : '#dc3545', borderTop: '2px solid #dee2e6' }}>
                  {formatCurrency(dados.saldo)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Lista de Empresas */}
      <div style={{ backgroundColor: 'white', padding: isMobile ? '15px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
        <h3 style={{ fontSize: isMobile ? '16px' : '18px' }}>📋 Lista de Empresas</h3>
        <div style={{ overflowX: 'auto' }}>
          {dados.empresas.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '30px' }}>
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>📭</div>
              <p style={{ color: '#6c757d', fontSize: isMobile ? '13px' : '14px' }}>Nenhuma empresa cadastrada</p>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>ID</th>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Nome</th>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>CNPJ</th>
                  <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Email</th>
                  <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #dee2e6' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {dados.empresas.map(empresa => (
                  <tr key={empresa.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                    <td style={{ padding: '10px' }}>{empresa.id}</td>
                    <td style={{ padding: '10px' }}><strong>{empresa.nome}</strong></td>
                    <td style={{ padding: '10px' }}>{empresa.cnpj}</td>
                    <td style={{ padding: '10px' }}>{empresa.email}</td>
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      <span style={{
                        padding: '3px 10px',
                        borderRadius: '12px',
                        backgroundColor: empresa.ativo ? '#d4edda' : '#f8d7da',
                        color: empresa.ativo ? '#155724' : '#721c24'
                      }}>
                        {empresa.ativo ? '✅ Ativo' : '❌ Inativo'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default DashboardAdmin;